module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "health-status.4187a723.png";